// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2WZeO","emails":"CreateEditClinics_emails__2elDV","emailTagLabel":"CreateEditClinics_emailTagLabel__1kPh1"};